import React, { useEffect, useState, useRef } from "react";
import axios from "../../../apis/Api";
import { connect } from "react-redux";
import {
  getUsersStatusReport,
  downloadUserDetailJob,
} from "./UsersStatusAction";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { getDropdownList } from "../../Shared/dropdownListActions";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_USER_ROLES,
} from "../../../Types";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link, Redirect } from "react-router-dom";
import { isPermittedPage } from "../../../apis/Utility";
const UserStatus = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [distributionId, setDistributionId] = useState(null);
  const [distCenterId, setdistCenterId] = useState(null);

  const [filterOptionsUserType, setFilterOptionsUserType] = useState(null);
  const [filterUserType, setFilterUserType] = useState(null);
  const [userType, setUserType] = useState(null);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [
    addOrderDistributionCentersOptions,
    setAddOrderDistributionCentersOptions,
  ] = useState(null);
  const [addJobDistributorsOptions, setAddJobDistributorsOptions] =
    useState(null);
  const [filterDistributionCenter, setFilterDistributionCenter] =
    useState(null);
  const [filterOptionsRolesList, setfilterOptionsRolesList] = useState(null);
  const [filteruserRolesList, setUserRolesList] = useState("");
  const [roleType, setroleType] = useState(null);
  const [addStatusOptions, setAddStatusOptions] = useState([
    {
      value: true,
      label: "Upgraded",
    },
    {
      value: false,
      label: "Not Upgraded",
    },
  ]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterVizId, setFilterVizId] = useState("");
  const [filterMobile, setfilterMobile] = useState("");
  useEffect(() => {
    setCurrentPageNo(0);
    let requestData = {
      DistributorId: distributionId,
      DistCenterId: distCenterId,
      pageSize: currentPageSize,
      pageNo: 0,
      searchText: searchText,
      vizId: filterVizId,
      mobile: filterMobile,
      status: filterStatus == null ? null : filterStatus.value,
      isExport: false,
      userType: userType,
    };
    props.getUsersStatusReport(requestData);
  }, [searchText]);

  const getData = (page) => {
    setCurrentPageNo(page);
    let requestData = {
      DistributorId: distributionId,
      DistCenterId: distCenterId,
      vizId: filterVizId,
      mobile: filterMobile,
      status: filterStatus == null ? null : filterStatus.value,
      pageSize: currentPageSize,
      pageNo: page,
      searchText: searchText,
      isExport: false,
      userType: userType,
    };
    props.getUsersStatusReport(requestData);
  };

  const searchChanged = (textsearch) => {
    setSearchText(textsearch);
  };
  const pageSizeChanged = (page) => {
    setCurrentPageNo(0);
    setCurrentPageSize(page);
    let requestData = {
      DistributorId: distributionId,
      DistCenterId: distCenterId,
      vizId: filterVizId,
      mobile: filterMobile,
      status: filterStatus == null ? null : filterStatus.value,
      pageSize: page,
      pageNo: 0,
      searchText: searchText,
      isExport: false,
      userType: userType,
      roleType: roleType,
    };
    props.getUsersStatusReport(requestData);
  };

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const [filterValuesModal, setFilterValuesModal] = useState({
    DistributorId: "",
    DistCenterId: "",
  });

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    let requestData = {
      DistributorId: distributionId,
      DistCenterId: distCenterId,
     vizId: filterVizId,
      mobile: filterMobile,
      status: filterStatus == null ? null : filterStatus.value,
      pageSize: currentPageSize,
      pageNo: 0,
      searchText: searchText,
      isExport: false,
      userType: userType,
      roleType: roleType,
    };

    props.getUsersStatusReport(requestData);
    setShow(false);
    setTarget(null);
  };

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
    props.getDropdownList(`api/Authenticate/GetUserRoles`, GET_USER_ROLES);
  }, []);
  useEffect(() => {
    setAddJobDistributorsOptions(
      props.allDistributorList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allDistributorList]);

  useEffect(() => {
    setFilterOptionsUserType(
      props.Roles.map(function (item) {
        return {
          value: item.id,
          label: item.name,
        };
      })
    );
  }, [props.Roles]);

  useEffect(() => {
    if (distributionId !== null) {
      props.getDropdownList(
        `api/DistCenter/GetDistCentersDDL/${distributionId}`,
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
  }, [distributionId]);

useEffect(() => {
  axios
    .get(`api/UserRoles`)
    .then(({ data }) => {
      if (data?.response) {
        setfilterOptionsRolesList(
          data.response.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching user roles:", error);
    });
},[]);

  useEffect(() => {
    setAddOrderDistributionCentersOptions(
      props.addJobDistCentersddlList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.addJobDistCentersddlList]);
  const handleResetFilters = (resetForm) => {
    resetForm();
    setCurrentPageNo(0);
    setDistributionId(null);
    setdistCenterId(null);
    setFilterVizId("");
    setfilterMobile("");
    setFilterStatus(null);
    setFilterDistributionCenter(null);
    setFilterDistributorName(null);
    setAddOrderDistributionCentersOptions([]);
    setFilterUserType([]);
    setUserType("");
    setroleType("");
  };

  const Download = () => {
    let requestData = {
      DistributorId: distributionId,
      DistCenterId: distCenterId,
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      vizId: filterVizId,
      mobile: filterMobile,
      status: filterStatus == null ? null : filterStatus.value,
      isExport: true,
      userType: userType,
    };
    props.downloadUserDetailJob(requestData);
  };
  const columns = [
    {
      Header: "VizId",
      accessor: "vizId",
    },
    {
      Header: "Shop Name",
      accessor: "shopName",
    },
    {
      Header: "Full Name",
      accessor: "fullName",
    },
     {
      Header: "CNIC",
      accessor: "cnic",
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "role",
    },
      {
      Header: "Module Type",
      accessor: "moduleType",
    },
    {
      Header: "Shopkeeper Type",
      accessor: "shopkeeperType",
    },
  ];
  return (
    <>
      <VzPageContainer title="User Details Report">
        <Row>
          <Col md={{ span: 3 }} style={{ float: "left" }}>
            <h4>
              <b>User Details Report</b>
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ float: "right" }}>
            <Row>
              <Col md={9} style={{ float: "right" }}>
                <div ref={ref}>
                  <Button
                    onClick={openFilterModal}
                    className="m-3"
                    variant="outline-primary"
                  >
                    <i className="fa fa-filter" />
                    Filters
                  </Button>

                  <Overlay
                    show={show}
                    target={target}
                    placement="bottom"
                    container={ref}
                    containerPadding={20}
                    width="430px"
                    style={{ width: "430px" }}
                  >
                    <Popover
                      id="popover-contained"
                      style={{ maxWidth: "360px", width: "360px" }}
                    >
                      <Popover.Header as="h3">Filters</Popover.Header>
                      <Popover.Body>
                        <Formik
                          enableReinitialize
                          initialValues={filterValuesModal}
                          validator={() => ({})}
                          onSubmit={LoadDataByfilter}
                        >
                          {(formik) => (
                            <Form autoComplete="off">
                              <Row>
                                <Col xs={12} md={12}>
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    label="Distributor Name"
                                    name="distributorName"
                                    options={addJobDistributorsOptions}
                                    isClearable={true}
                                    isSearchable={true}
                                    handleOnChange={(e) => {
                                      if (!e || !e.value) {
                                        setFilterDistributionCenter(null);
                                        setFilterDistributorName(null);
                                        return;
                                      }
                                      setDistributionId(e.value);
                                      setFilterDistributorName({
                                        label: e.label,
                                        value: e.value,
                                      });
                                      setFilterDistributionCenter(null);
                                    }}
                                    value={filterDistributorName}
                                  />
                                </Col>
                                <Col xs={12} md={12}>
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    label="Distribution Center"
                                    name="distributionCenter"
                                    options={addOrderDistributionCentersOptions}
                                    isClearable={true}
                                    isSearchable={true}
                                    handleOnChange={(e) => {
                                      if (!e || !e.value) {
                                        setFilterDistributionCenter(null);
                                        return;
                                      }
                                      filterValuesModal.distributionCenter =
                                        e.value;
                                      setdistCenterId(e.value);
                                      setFilterDistributionCenter({
                                        label: e.label,
                                        value: e.value,
                                      });
                                    }}
                                    value={filterDistributionCenter}
                                  />
                                </Col>

                                <Col xs={12} md={12}>
                                  <div className="form-group">
                                    <FormikControl
                                      formik={formik}
                                      control="input"
                                      label="Viz Id"
                                      name="vizId"
                                      maxLength={13}
                                      handleOnChange={(value) => {
                                        setFilterVizId(value);
                                      }}
                                      value={filterVizId}
                                    />

                                    <FormikControl
                                      formik={formik}
                                      control="input"
                                      type="mobile"
                                      label="Contact No."
                                      name="mobile"
                                      maxLength={11}
                                      handleOnChange={(value) => {
                                        setfilterMobile(value);
                                      }}
                                      value={filterMobile}
                                    />
                                    
                                    <FormikControl
                                      formik={formik}
                                      control="react-select"
                                      label="Module Type"
                                      name="userType"
                                      options={filterOptionsUserType}
                                      isSearchable={true}
                                      handleOnChange={(e) => {
                                        if (!e || !e.value) {
                                          return;
                                        }
                                        setFilterUserType({
                                          label: e.label,
                                          value: e.value,
                                        });
                                        setUserType(e.value);
                                      }}
                                      value={filterUserType}
                                    />

                                    <FormikControl
                                      formik={formik}
                                      control="react-select"
                                      label="Role"
                                      name="role"
                                      options={filterOptionsRolesList}
                                      isSearchable={true}
                                      handleOnChange={(e) => {
                                        if (!e || !e.value) {
                                          return;
                                        }
                                        setUserRolesList({
                                          label: e.label,
                                          value: e.value,
                                        });
                                        setroleType(e.value);
                                      }}
                                      value={filteruserRolesList}
                                    />

                                    <FormikControl
                                      formik={formik}
                                      control="react-select"
                                      label="Upgradation Status"
                                      name="Status"
                                      options={addStatusOptions}
                                      isSearchable={true}
                                      handleOnChange={(e) => {
                                        setFilterStatus({
                                          label: e.label,
                                          value: e.value,
                                        });
                                      }}
                                      value={filterStatus}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <div className="row">
                                <div className="form-group">
                                  <Link
                                    onClick={handleResetFilters.bind(
                                      null,
                                      formik.resetForm
                                    )}
                                    to="#"
                                    className="active"
                                    style={{
                                      padding: "0px",
                                      marginTop: "10px",
                                      float: "left",
                                    }}
                                  >
                                    Reset
                                  </Link>
                                  <Link
                                    onClick={() => {
                                      setShow(false);
                                      setTarget(null);
                                    }}
                                    to="#"
                                    className="active"
                                    style={{
                                      padding: "0px",
                                      marginTop: "10px",
                                      float: "right",
                                    }}
                                  >
                                    Cancel
                                  </Link>
                                  <div className="float-right">
                                    <Button
                                      type="submit"
                                      className="btn btn-primary"
                                      style={{
                                        marginRight: "10px",
                                        float: "right",
                                      }}
                                    >
                                      Apply
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </div>
              </Col>
              <Col md={3} style={{ float: "right" }}>
                {isPermittedPage("Export", props.actions, props.userRole) && (
                  <Button
                    onClick={Download}
                    className="m-3"
                    variant="outline-primary"
                    style={{ float: "right" }}
                  >
                    <i className="fa fa-download me-1" />
                    Export
                  </Button>
                )}
              </Col>
            </Row>
            <ServerSideDataTable
              data={props.UserStatusReport ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={props.TotalUser ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}></Col>
        </Row>
      </VzPageContainer>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],

    addJobDistCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    UserStatusReport: state.UsersStatus.UserStatusReport.records,
    TotalUser: state.UsersStatus.UserStatusReport.totalUsers,
    Roles: state.ddlList?.userRoles ? state.ddlList?.userRoles : [],
  };
};
export default connect(mapStateToProps, {
  getUsersStatusReport,
  getDropdownList,
  downloadUserDetailJob,
})(UserStatus);

//export default UserStatus;
